import { useMutation } from '@tanstack/react-query'
import {
  learnerGamesApi,
  type GameRankingEntry,
} from '@/api/learnerGames'

export interface SubmitGameScoreVars {
  key: string
  score: number
  time?: number | null
  sub?: string | null
}

/** 점수 제출 → 게임 onComplete 콜백이 읽는 랭킹 엔트리({rank,score,time,user.nickname}) 반환 */
export function useSubmitGameScore() {
  return useMutation<GameRankingEntry, Error, SubmitGameScoreVars>({
    mutationFn: async ({ key, score, time, sub }) => {
      const res = await learnerGamesApi.submitScore(key, { score, time, sub })
      return res.data.data
    },
  })
}
